<script setup lang="ts">
import { TabsTrigger, type TabsTriggerProps } from "radix-vue";
import { cn } from "@/lib/utils";

const props = defineProps<TabsTriggerProps & { class?: string }>();
</script>

<template>
    <TabsTrigger
        v-bind="props"
        :class="
            cn(
                'data-[state=active]:ring-offset-red h-10 px-3 py-1.5 text-sm font-medium text-iron-600 ring-iron-200 ring-offset-white focus-visible:ring-stone-950 data-[state=active]:bg-z-primary-25 data-[state=active]:text-iron-700 data-[state=active]:shadow-sm data-[state=active]:ring-iron-900 data-[state=active]:ring-z-primary-500 data-[state=active]:ring-offset-z-primary-500 dark:ring-offset-stone-950 dark:focus-visible:ring-stone-300 dark:data-[state=active]:bg-stone-950 dark:data-[state=active]:text-stone-50 ml-[2px] inline-flex items-center justify-center whitespace-nowrap ring-[1px] ring-offset-1 transition-all outline-none focus-visible:ring-1 focus-visible:ring-offset-2 focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50 data-[state=active]:z-10',
                props.class,
            )
        "
    >
        <slot name="icon" />

        <slot />
    </TabsTrigger>
</template>
